import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import {
  fetchTokens,
  deleteToken,
} from '../../actions';

const dateFormat = 'L LT';

class DeleteApi extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.tokenDelete = this.tokenDelete.bind(this);
  }

  tokenDelete(id) {
    const { dispatch } = this.props;
    dispatch(deleteToken(id))
      .then((res) => {
        dispatch(fetchTokens());
      });
  }

  render() {
    const { apitokens, tempAnon } = this.props;

    const tokenLoop = apitokens && apitokens.map((item, index) => {

      let createdAt;
      let expiresAt;
      let refId;

      if (item && item.referenceId) {
        refId = item.referenceId;
      }

      if (item && item.createdAt) {
        createdAt = moment.unix(item.createdAt).format(dateFormat);
      }

      if (item && item.expires) {
        expiresAt = moment.unix(item.expires).format(dateFormat);
      }

      return (
        <tr key={index}>
          <td>
            <span className={tempAnon ? 'eyeblur' : ''}>
              {refId}
            </span>
          </td>
          {/* <td>[TODO scope]</td> */}
          <td>{createdAt}</td>
          <td>{expiresAt}</td>
          <td>
            <FontAwesomeIcon
              style={{
                color: 'rgb(255, 99, 51)',
              }}
              size="lg"
              icon={faTimes}
              className={'del-icon'}
              onClick={() => this.tokenDelete(refId)}
            />
          </td>
        </tr>
      );
    });

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Delete API tokens</div>
            <div className="modal-subheading">
              Click a red cross icon to delete the API token.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            {apitokens && apitokens.length ? (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Token Reference</th>
                      {/* <th>Scope</th> */}
                      <th>Created At</th>
                      <th>Expires At</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tokenLoop}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Token Reference</th>
                      {/* <th>Scope</th> */}
                      <th>Created At</th>
                      <th>Expires At</th>
                      <th></th>
                    </tr>
                  </thead>
                </table>
                <h3 className="no-data">No API Tokens</h3>
              </div>
            )}
          </div>
          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className='button' type="submit" onClick={() => this.props.toggleModal(null)}>
              <span>
                Close
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  newtoken: state.user.newtoken,
  apitokens: state.user.apitokens,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(DeleteApi);
